// extracted by mini-css-extract-plugin
export default {"root":"_0TZoF","autopromo":"i16Yb","geoentitiesAtAdressTitle":"TsvFj","descriptionWrapper":"zh3PE"};